import {
  TableContainer,
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Divider,
} from '@mui/material';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import HighlightSyntax from './HighlightSyntax';
import FormatLink from './FormatLink';
import { PromptSummaryReferenceType } from './hooks/useBuildWiseGPTHistoryQuery';

type RenderLLMMarkdownProps = {
  llmResponse: string;
  metaData?: PromptSummaryReferenceType[];
  metaDataOrder?: {
    originalValue: number;
    orderValue: number;
  }[];
};

function RenderLLMMarkdown({
  llmResponse,
  metaData = [],
  metaDataOrder = [],
}: RenderLLMMarkdownProps) {
  return (
    <>
      <Markdown
        className="line-break"
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          table: (props) => (
            <TableContainer
              component={Paper}
              sx={(theme) => ({
                boxShadow: `0 4px 24px ${theme.palette.custom.boxShadow}`,
              })}
            >
              <Table>{props.children}</Table>
            </TableContainer>
          ),
          th: (props) => <TableCell>{props.children}</TableCell>,
          thead: (props) => <TableHead>{props.children}</TableHead>,
          tr: (props) => <TableRow>{props.children}</TableRow>,
          tbody: (props) => <TableBody>{props.children}</TableBody>,
          td: (props) => <TableCell>{props.children}</TableCell>,
          a: (props) => <FormatLink {...props} metaData={metaData} metaDataOrder={metaDataOrder} />,
          code: HighlightSyntax,
          hr: () => <Divider />,
        }}
      >
        {llmResponse}
      </Markdown>
    </>
  );
}

export default RenderLLMMarkdown;
